import createNotificationObj from "../../../objects/CommonUse/create_notification_obj";
import createInvestPayoutText from "./create_invest_payout_text";

export const endOfTurnTaxCalculation = (totalRegularTaxAmt, totalCapitalTaxAmt, totalSavingsTaxAmt,
    notificationArr, taxDate) => {
   
    let totalTaxAmt = 0;
    let taxPayoutArr = [];
    if (totalRegularTaxAmt !== 0){
        const taxAmt = totalRegularTaxAmt * -1;
        const tranInfo = {tranType: "Tax Paid - Investments",  dateClosed: taxDate, sellAmount: taxAmt, 
            investmentName: "Federal Income Tax"}
        taxPayoutArr.push(tranInfo);
    }
    if (totalCapitalTaxAmt !== 0){
        const taxAmt = totalCapitalTaxAmt * -1;
        const tranInfo = {tranType: "Tax Paid - Investments", dateClosed: taxDate, sellAmount: taxAmt, 
            investmentName: "Capital Gains Tax"}
        taxPayoutArr.push(tranInfo);
    }
    if (totalSavingsTaxAmt !== 0){
        const taxAmt = totalSavingsTaxAmt * -1;
        const tranInfo = {tranType: "Tax Paid - Savings",  dateClosed: taxDate, sellAmount: taxAmt, 
            investmentName: "Federal Income Tax"}
        taxPayoutArr.push(tranInfo);
    }
    if (taxPayoutArr.length > 0){
        // rework taxPayoutArr....   here is the object need to string together to make it text
        const investPayoutTextObj  = createInvestPayoutText(taxPayoutArr);
        totalTaxAmt = investPayoutTextObj.cashChg
        const additionalText = investPayoutTextObj.additionalText;
        const notificationObj = createNotificationObj("federalTax", additionalText);
        notificationArr.push(notificationObj)
    }
  
    return totalTaxAmt;
}
export default endOfTurnTaxCalculation;